module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQBAMAAAB8P++eAAAAG1BMVEUAAABPrf9Prf9V1f9OrP/L5f3g8P+83P7V6v/iOnJfAAAABHRSTlMAiOYGvfLd/QAAAGpJREFUSMdjGMnABQ8gU2E5TjB4FOIOEHIVhuIEg0fhqK+p4+sODABUAaYHj0LcviBXYRoGAKoA04NH4aivUcWop9DQRZg4hSIujsQpVHFxIk8h5VYbKgkTXQCMKhxVOKqQpgpp0CIdwQAAmrM3pB4OdPUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/sub/4.png
// module id = 818
// module chunks = 1